import { emailtemplateConstants } from '../constants';

export function emailtemplates(state = {}, action) {
  switch (action.type) {

    case emailtemplateConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case emailtemplateConstants.GETALL_SUCCESS:
      return {
        items: action.emailtemplates
      };
    case emailtemplateConstants.GETALL_FAILURE:
      return {
        error: action.error
      };

    case emailtemplateConstants.DELETE_REQUEST:
      // add 'deleting:true' property to emailtemplate being deleted
      return {
        ...state,
        items: state.items.map(emailtemplate =>
          emailtemplate.id === action.id
            ? { ...emailtemplate, deleting: true }
            : emailtemplate
        )
      };
    case emailtemplateConstants.DELETE_SUCCESS:
      // remove deleted emailtemplate from state
      return {
        items: state.items.filter(emailtemplate => emailtemplate.id !== action.id)
      };
    case emailtemplateConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to emailtemplate
      return {
        ...state,
        items: state.items.map(emailtemplate => {
          if (emailtemplate.id === action.id) {
            // make copy of emailtemplate without 'deleting:true' property
            const { deleting, ...emailtemplateCopy } = emailtemplate;
            // return copy of emailtemplate with 'deleteError:[error]' property
            return { ...emailtemplateCopy, deleteError: action.error };
          }

          return emailtemplate;
        })
      };

    default:
      return state
  }
}
